import ZoneSelectView from 'performance-zone-select.view';
import * as React from 'react';
import { connect } from 'react-redux';
import { IZone } from '../../custom/classes/production';
import { IPackageListingAppState } from '../../redux-state';
import { updateSelectedZone, toggleMiniCart } from '../../redux-state/actions/package-listing.actions';
import { flatMap } from 'lodash';
import { getCartItemDetails } from '../../helpers/cart-helpers';


interface StateToProps {
    zones: Array<IZone>;
    missingPriceTypeSelectionMessage: string;
    selectAZoneLabel: string;
    selectAZoneDropdownDefaultValue: string;
    requiresPriceTypeSelection: boolean;
    selectedPriceTypeQuantities: Map<number, number>;
    venueZoneMapImageUrl: string;
    isVoucherPackage: boolean;
}

interface IZoneSelectExternalProps {
    itemId: number;
    selectedZone: IZone;
    showPriceTypeError: boolean;
}

interface DispatchToProps {
    selectZone: (priceTypeId, quantity) => void;
    toggleMiniCart: (open: boolean) => void;
}

export type ZoneSelectProps = StateToProps & IZoneSelectExternalProps & DispatchToProps;


export class ZoneSelectBase extends React.Component<ZoneSelectProps, any> {
    constructor(props: ZoneSelectProps) {
        super(props);
    }

    componentDidUpdate() {
        if (this.props.isVoucherPackage && this.props.zones.length > 0 && !this.props.selectedZone) {
            this.props.selectZone(this.props.itemId, this.props.zones[0].zone.id);
        }
    }

    render() {
        return <ZoneSelectView {...this.props} {...this.state} />;
    }
}

function mapStateToProps(state: IPackageListingAppState, ownProps: ZoneSelectProps): StateToProps {
    var selectedPriceTypes = [];

    Array.from(state.packageListing.priceTypeQuantity.keys()).forEach(pt => {
        var quantity = state.packageListing.priceTypeQuantity.get(pt);
        var i;
        for (i = 0; i < quantity; i++) {
            selectedPriceTypes.push(pt);
        }

    });

    let itemDetail = getCartItemDetails(state, ownProps.itemId);
    var isSuperPackage = false;

    let performancePricing = state.packageListing.performancePricingList.get(ownProps.itemId);

    if (!performancePricing) {
        isSuperPackage = true;
        performancePricing = state.packageListing.performancePricingList.get(itemDetail.itemIdToRemove);
    }

    var zoneList = performancePricing ? performancePricing.zones
        .filter(z => z.prices.map(pr => pr.priceTypeId)
            .filter(value => -1 !== selectedPriceTypes.indexOf(value)).length > 0) : [];

    
    return {
        requiresPriceTypeSelection: selectedPriceTypes.length < 1,
        zones: isSuperPackage ? zoneList.filter(z => z.performanceId === ownProps.itemId) : zoneList,
        selectedPriceTypeQuantities: state.packageListing.priceTypeQuantity,
        missingPriceTypeSelectionMessage: state.packageListingText.missingPriceTypeSelectionMessage,
        selectAZoneLabel: state.packageListingText.selectAZoneLabel,
        selectAZoneDropdownDefaultValue: state.packageListingText.selectAZoneDropdownDefaultValue,
        venueZoneMapImageUrl: itemDetail.facility.facilityImageUrl,
        isVoucherPackage: state.packageListingSettings.voucherPackage
    }
}

function mapDispatchToProps(dispatch, ownProps: ZoneSelectProps): DispatchToProps {
    return {
        selectZone: (itemId, zoneId) => {
            dispatch(updateSelectedZone(itemId, zoneId));
        },
        toggleMiniCart: (open: boolean) => {
            dispatch(toggleMiniCart(open));
        }

    }
}

export default connect<StateToProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(ZoneSelectBase);